type DiscordIdentity = {
  id: number;
  discordName?: string | null;
  guildNickname?: string | null;
  discordUsername?: string | null;
  firstNameLastInitial?: string | null;
  name?: string | null;
  callsign?: string | null;
};

/** Use the same server nickname / Discord username fallback as the Discord sync. */
export function discordDisplayName(member: DiscordIdentity): string {
  return (
    member.discordName?.trim() ||
    member.guildNickname?.trim() ||
    member.discordUsername?.trim() ||
    member.firstNameLastInitial?.trim() ||
    member.name?.trim() ||
    `Member #${member.id}`
  );
}

export function discordNameWithCallsign(member: DiscordIdentity): string {
  const name = discordDisplayName(member);
  const callsign = member.callsign?.trim();
  return callsign && !name.toLowerCase().includes(callsign.toLowerCase())
    ? `${name} · ${callsign}`
    : name;
}
